import { PopoverIframeComponent } from "./popover-iframe/popover-iframe.component";
import { PopoverWebviewComponent } from "./popover-webview/popover-webview/popover-webview.component";
import { SearchbarComponent } from "./searchbar/searchbar.component";
import { PopoverContentComponent } from "./popover-content/popover-content.component";
import { PopoverDailySpinResultComponent } from "./popover-daily-spin-result/popover-daily-spin-result.component";
import { PopoverSessionStatsComponent } from "./popover-session-stats/popover-session-stats.component";
import { PopoverFavouritesComponent } from "./popover-favourites/popover-favourites.component";
import { PopoverPreGeoInfoComponent } from "./popover-pre-geo-info/popover-pre-geo-info.component";
import { PopoverSelfExcludeComponent } from "./popover-self-exclude/popover-self-exclude.component";
import { VipTermsComponent } from "./popover-vipterms/popover-vipterms.component";
import { PopoverAlertComponent } from "./popover-alert/popover-alert.component";
import { PopoverStandardConfirmComponent } from "./popover-standard-confirm/popover-standard-confirm.component";
import { PopoverReconfirmationComponent } from "./popover-reconfirmation/popover-reconfirmation.component";
import { PopoverGameHistoryDetailsComponent } from "./popover-game-history-details/popover-game-history-details.component";
import { PopoverMarketingComponent } from "./popover-marketing/popover-marketing.component";
import { PopoverAgreementComponent } from "./popover-agreement/popover-agreement.component";
import { PopoverDarkWebviewComponent } from "./popover-webview/popover-dark-webview/popover-dark-webview.component";
import { BehalfDeclarationPopover } from "./behalf-declaration/behalf-declaration";
import { PopoveApprateComponent } from './popover-apprate/popover-apprate.component';
import { PopoverAvailableGamesComponent } from "./popover-available-games/popover-available-games.component";
import { RestrictedMoneyPopover } from "./popover-restricted-money/restricted-money";
import { W2GPopover } from "./w2g/w2g";
import { PromotionDetailsPopoverComponent } from "./popover-promotion-details/popover-promotion-details.component";
import { BonusCheckPopoverComponent } from "./popover-bonus-check/popover-bonus-check.component";
import { LoyaltyPopover } from "./loyalty/loyalty";
import { PopoverStringHtmlDisplayComponent } from "./popover-string-html-display/popover-string-html-display.component";

const popoverFactory: Object = {
    SearchbarComponent: SearchbarComponent,
	PopoverAlertComponent: PopoverAlertComponent,
	BehalfDeclarationPopover: BehalfDeclarationPopover,
	PopoverWebview: PopoverWebviewComponent,
	PopoverDarkWebview: PopoverDarkWebviewComponent,
	VipTermsComponent: VipTermsComponent,
	PopoveriFrame: PopoverIframeComponent,
	PopoverContent: PopoverContentComponent,
	PopoverDailySpinResultComponent: PopoverDailySpinResultComponent,
	PopoverSessionStats: PopoverSessionStatsComponent,
	PopoverFavourites: PopoverFavouritesComponent,
	PreGeoInfoPopover: PopoverPreGeoInfoComponent,
	PopoverSelfExcludeComponent: PopoverSelfExcludeComponent,
	PopoverStandardConfirmComponent: PopoverStandardConfirmComponent,
	PopoverGameHistoryDetailsComponent: PopoverGameHistoryDetailsComponent,
	PopoverStringHtmlDisplayComponent: PopoverStringHtmlDisplayComponent,
	PopoverMarketingComponent: PopoverMarketingComponent,
	PopoverAgreementComponent: PopoverAgreementComponent,
	PopoveApprateComponent: PopoveApprateComponent,
	PopoverReconfirmation: PopoverReconfirmationComponent,
	PopoverAvailableGames: PopoverAvailableGamesComponent,
	RestrictedMoneyPopover: RestrictedMoneyPopover,
	W2GPopover: W2GPopover,
	PromotionDetailsPopoverComponent: PromotionDetailsPopoverComponent,
	BonusCheckPopoverComponent: BonusCheckPopoverComponent,
	LoyaltyPopover:LoyaltyPopover
};

export const PopoverClass = className => {
	if (className in popoverFactory) {
		return popoverFactory[className];
	}
	return console.log(`"No popover match for " + ${className}`);
};